import React from 'react';
import { Link } from 'react-router-dom';
import { platforms } from '../mock/mock';
import { ArrowUpRight } from 'lucide-react';
import { PlatformLogo } from './PlatformLogo';

const Categories = () => {
  return (
    <section className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="flex items-end justify-between flex-wrap gap-4 mb-12">
          <div>
            <div className="text-[#ff8247] text-xs font-bold uppercase tracking-widest mb-3">Nos Réseaux</div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              Boostez chaque <span className="gradient-text">plateforme</span>
            </h2>
            <p className="text-white/60 mt-4 max-w-xl">
              Une solution complète pour tous vos réseaux. Choisissez, commandez, et laissez notre algorithme s’occuper du reste.
            </p>
          </div>
          <Link to="/collections" className="btn-ghost inline-flex items-center gap-2 text-sm">
            Tout voir <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {platforms.map((p, idx) => (
            <Link to={`/collections/${p.slug}`} key={p.id}
              className="tilt-card group relative rounded-3xl overflow-hidden border border-white/10 aspect-[5/6] bg-gradient-to-br from-white/[0.04] to-transparent"
              style={{ animationDelay: `${idx * 60}ms` }}>
              <div className="absolute inset-0 opacity-30 group-hover:opacity-45 transition-opacity duration-500"
                   style={{ background: `radial-gradient(ellipse at 30% 20%, ${p.color}55 0%, transparent 60%)` }} />

              <div className="absolute top-5 left-5">
                <div className="px-3 py-1 rounded-full bg-black/40 backdrop-blur border border-white/10">
                  <span className="text-[10px] font-bold text-white/70 uppercase tracking-widest">#{String(idx + 1).padStart(2, '0')}</span>
                </div>
              </div>

              <div className="absolute top-5 right-5 w-11 h-11 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:rotate-45"
                   style={{ background: p.color }}>
                <ArrowUpRight className="w-5 h-5 text-black" strokeWidth={2.5} />
              </div>

              <div className="absolute inset-0 flex items-center justify-center pt-8">
                <div className="relative">
                  <div className="w-40 h-40 rounded-full blur-3xl opacity-45" style={{ background: p.color }} />
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-24 h-24 rounded-2xl bg-white/[0.06] backdrop-blur-xl border border-white/10 flex items-center justify-center transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6">
                      <PlatformLogo platform={p.id} className="w-14 h-14 drop-shadow-2xl" color={p.id === 'instagram' ? undefined : p.color} />
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 via-black/40 to-transparent">
                <h3 className="text-white text-3xl font-bold mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>{p.name}</h3>
                <p className="text-white/60 text-sm leading-snug line-clamp-2">{p.desc}</p>
                <div className="mt-4 flex items-center gap-2">
                  <div className="h-px flex-1 bg-white/10" />
                  <span className="text-[10px] text-white/40 font-semibold uppercase tracking-widest">Découvrir</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Categories;
